import React, { useMemo } from 'react';
import { shouldShowField } from '../../../../../components/InputField/helper';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import "../../../../../components/SuperResponsiveTableStyle.css";
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
import { TRANSACTION_FIELDS } from '../../IPlushelper';
const Page3 = ({
  asLabel,
  data,
  handleChangeObject,
  hasError,
  validationkeyValue,
  skipExpectedActivity
}) => {
  const expectedActivityFields = useMemo(() => ["Amount_Of_Initial_Deposit", ...TRANSACTION_FIELDS, "Expected_Amount_Monthly_Digital_Currency_Custody"], []);
  const conversionPlanFields = useMemo(() => [{
    field: "hasCoinConversionPlan",
    question: "Do you plan on converting stablecoins to/from fiat in FV Bank? (USDC, USDT, PYUSD or similar)"
  }, {
    field: "hasCryptoConversionPlan",
    question: "Do you plan on converting cryptocurrencies to/from fiat in FV Bank? (BTC, ETH, or similar)"
  }], []);
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeObject
  });
  const shouldRenderExpectedActivity = !skipExpectedActivity;
  const hasAnyExpectedField = expectedActivityFields.some(field => validationkeyValue?.[field]);
  return <div>
    <h2 style={{
      fontWeight: 'bolder'
    }} className='pt-3'>About your business</h2>

    {renderWrapperField('Primary_Business_Activities')}

    {renderWrapperField('Business_Product_Services')}

    {renderWrapperField('Customer_Description')}

    {renderWrapperField('Business_Plan_Disclosure')}
    {renderWrapperField('Illegal_Immoral_Disclosure')}

    <h2 style={{
      fontWeight: 'bolder'
    }} className='pt-3'>Expected Bank Account Activity</h2>
    {renderWrapperField('Deposit_Reasons')}

    {renderWrapperField('Payment_Reasons')}

    {renderWrapperField('Deposit_Locations')}

    {renderWrapperField('Payment_Locations')}

    {shouldRenderExpectedActivity ? <>
      <div className="mt-4">
        {conversionPlanFields.map(({
          field
        }) => validationkeyValue?.[field] ? <WrapperField key={field} disabled={asLabel} jsonField={validationkeyValue?.[field]} dataObj={data} onChange={handleChangeObject} showError={hasError} onError={() => { }} /> : null)}
      </div>

      {hasAnyExpectedField ? <div className="transaction-table p-0 mb-3 mt-4">
        <table className="transaction-value-table">
          <thead>
            <tr>
              <th className="header-cell">Question</th>
              <th className="header-cell text-end value-cell">Expected Activity</th>
            </tr>
          </thead>
          <tbody>
            {expectedActivityFields.map(field => {
              const jsonField = validationkeyValue?.[field];
              if (!jsonField) return null;
              const isFieldVisible = shouldShowField(data, jsonField?.showIf);
              return <tr key={field} style={isFieldVisible ? undefined : { display: 'none' }}>
                <td>{jsonField?.label}</td>
                <td className="p-0 m-0 transaction-input text-end value-cell">
                  <WrapperField disabled={asLabel} jsonField={jsonField} dataObj={data} onChange={handleChangeObject} showError={hasError} onError={() => { }} customProp="plain" />
                </td>
              </tr>;
            })}
          </tbody>
        </table>
      </div> : null}
    </> : null}

  </div>;
};
export default Page3;
